<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Sutarties dokumento duomenys</h3>
    <div class="dataContainer mb-3">
      <template v-if="isPrasymasIregistravimas">
        <template v-if="isPrasymasNuoma || isPrasymasSubnuoma">
          <v-row>
            <v-col cols="12" md="3">
              <el-text-field
                label="Mokėjimo diena"
                :tooltip="`${ntrTooltipPrefix} Sutartis. Mokėjimo diena`"
                :need="!isReadonlyForm"
                :readonly="isReadonlyForm"
                hide-details="auto"
                validate-key="mokejimo_diena"
                v-mask="`##`"
                month-day
                v-model="formData.sut_mokejimo_diena"
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-text-field
                label="Banko sąskaitos numeris"
                :tooltip="
                  `${ntrTooltipPrefix} Sutartis. Banko sąskaitos numeris`
                "
                :need="!readonlyBankoSaskaita"
                :readonly="readonlyBankoSaskaita"
                hide-details="auto"
                validate-key="banko_saskaita"
                v-mask="saskaitaMask"
                placeholder="LT## ##### ###########"
                v-model="formData.sut_banko_saskaita"
              />
            </v-col>
            <v-col cols="12" md="6" v-if="showKeliosSaskaitos" class="mb-2">
              <el-checkbox
                label="Mokama į kelias banko sąskaitas"
                :tooltip="
                  `${ntrTooltipPrefix} Sutartis. Mokama į kelias banko sąskaitas`
                "
                class="mt-4"
                :readonly="isReadonlyForm"
                validate-key="kelios_saskaitos"
                v-model="keliosSaskaitos"
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="showMokejimoInformacija"
              class="mt-2 mb-3"
            >
              <el-textarea
                :readonly="isReadonlyForm"
                need
                label="Kita su mokėjimu susijusi informacija"
                :tooltip="
                  `${ntrTooltipPrefix} Sutartis. Kita su mokėjimu susijusi informacija`
                "
                counter="4000"
                hide-details="auto"
                validate-key="mokejimo_informacija"
                v-model="formData.sut_mokejimo_informacija"
              />
            </v-col>
            <v-col cols="12" md="3" class="mt-0">
              <el-text-field
                label="Užstato dydis, mėnesių sk."
                :tooltip="`${ntrTooltipPrefix} Sutartis. Užstato dydis`"
                :disabled="disabledUzstatoDydis"
                :need="!isReadonlyForm && !disabledUzstatoDydis"
                :readonly="isReadonlyForm"
                hide-details="auto"
                v-mask="`##`"
                validate-key="uzstato_dydis"
                v-model="formData.sut_uzstato_dydis"
              >
                <template slot="append-outer">
                  <div class="mt-2 nowrap no-color-label small-label"></div>
                </template>
              </el-text-field>
            </v-col>
            <v-col cols="12" md="3" class="mt-2">
              <el-checkbox
                label="Užstato dydis nenumatytas"
                :tooltip="`${ntrTooltipPrefix} Sutartis. Nenumatyta`"
                :readonly="isReadonlyForm"
                validate-key="nenumatyta"
                v-model="formData.sut_nenumatyta"
              />
            </v-col>
          </v-row>
        </template>
        <v-row class="pt-3 pb-3">
          <v-col cols="12" md="3">
            <el-date-picker
              :label="`${terminasNuoLabel} nuo`"
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${terminasNuoLabel} nuo`"
              :need="!isReadonlyForm"
              :readonly="isReadonlyForm"
              hide-details="auto"
              validate-key="terminas_nuo"
              v-model="formData.sut_terminas_nuo"
            />
          </v-col>
          <v-col cols="12" md="3">
            <el-date-picker
              :label="`${terminasNuoLabel} iki`"
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${terminasNuoLabel} iki`"
              :disabled="disabledTerminasIki"
              :need="!isReadonlyForm && !disabledTerminasIki"
              :readonly="isReadonlyForm"
              hide-details="auto"
              validate-key="terminas_iki"
              future-dates
              v-model="formData.sut_terminas_iki"
            />
          </v-col>
          <v-col cols="12" md="6" class="mt-2">
            <el-checkbox
              :label="neterminuotaLabel"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Neterminuota`"
              :readonly="isReadonlyForm"
              validate-key="neterminuota"
              v-model="formData.sut_neterminuota"
            />
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12" md="3" class="mt-3">
            <el-date-picker
              :label="perdavimoDataLabel"
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${perdavimoDataLabel}`"
              :need="!isReadonlyForm"
              :readonly="isReadonlyForm"
              hide-details="auto"
              validate-key="perdavimo_data"
              v-model="formData.sut_perdavimo_data"
            />
          </v-col>
          <v-col cols="12" md="3" class="mt-3">
            <el-text-field
              label="Įspėjimas apie sutarties nutraukimą, mėnesių sk."
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Įspėjimas apie sutarties nutraukimą`
              "
              :readonly="isReadonlyForm"
              hide-details="auto"
              v-mask="`##`"
              validate-key="sut_nutraukimo_ispejimas"
              v-model="formData.sut_nutraukimo_ispejimas"
            >
              <template slot="append-outer">
                <div class="mt-2 nowrap no-color-label small-label"></div>
              </template>
            </el-text-field>
          </v-col>
        </v-row>
        <v-row v-if="formData.sut_komunaliniai_show">
          <v-col cols="12" md="12">
            <el-checkbox
              :label="komunaliniaiLabel"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Komunaliniai mokesčiai`"
              class="mt-3"
              :readonly="isReadonlyForm"
              validate-key="komunaliniai"
              v-model="formData.sut_komunaliniai"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" class="mt-3">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Veiklos aprašymas"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Veiklos aprašymas`"
              :need="formData.sut_aprasymas_required"
              counter="4000"
              hide-details="auto"
              validate-key="aprasymas"
              v-model="formData.sut_aprasymas"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kiti įsipareigojimai"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Kiti įsipareigojimai`"
              counter="4000"
              hide-details="auto"
              validate-key="isipareigojimai"
              v-model="formData.sut_isipareigojimai"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <el-textarea
              :readonly="isReadonlyForm"
              label="Kiti nutraukimo pagrindai"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kiti nutraukimo pagrindai`
              "
              counter="4000"
              hide-details="auto"
              validate-key="nutraukimo_pagrindai"
              v-model="formData.sut_nutraukimo_pagrindai"
            />
          </v-col>
        </v-row>
      </template>

      <template v-if="!isPrasymasIregistravimas">
        <v-row class="pt-3">
          <v-col cols="12" md="4">
            <el-text-field
              label="Sutarties numeris"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties numeris`"
              :readonly="true"
              hide-details="auto"
              validate-key="sut_numeris"
              v-model="formData.sut_numeris"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :label="sutartisDataLabel"
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${sutartisDataLabel}`"
              :readonly="true"
              hide-details="auto"
              validate-key="sut_data"
              v-model="formData.sut_data"
            />
          </v-col>

          <v-col cols="12" md="4" class="pr-5" v-if="isPrasymasIsregistravimas">
            <el-text-field
              label="Sutarties pabaigos data"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties pabaigos data`"
              :readonly="true"
              hide-details="auto"
              validate-key="sut_pabaigos_data"
              v-model="formData.sut_pabaigos_data"
            />
          </v-col>
          <v-col cols="12" md="4" class="pr-5" v-if="isPrasymasNutraukimas">
            <el-date-picker
              label="Sutarties nutraukimo data"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties nutraukimo data`
              "
              :need="!isReadonlyForm"
              :readonly="isReadonlyForm"
              hide-details="auto"
              validate-key="sut_nutraukimo_data"
              v-model="formData.sut_nutraukimo_data"
            />
          </v-col>
        </v-row>
      </template>

      <v-row v-if="isPrasymasIregistravimas || isPrasymasNutraukimas">
        <v-col cols="12" md="12" class="mt-3">
          <el-textarea
            :readonly="isReadonlyForm"
            :label="sutartiesSalygosLabel"
            :tooltip="sutartiesSalygosTooltip"
            counter="4000"
            hide-details="auto"
            validate-key="salygos"
            v-model="formData.sut_salygos"
          />
        </v-col>
      </v-row>
    </div>

    <v-footer class="form-footer" v-if="!isReadonly">
      <el-button
        v-if="!isReadonlyForm"
        primary
        @click.native="saveData()"
        :loading="loading"
        >Saugoti</el-button
      >
      <el-button
        v-if="!isReadonlyForm"
        @click.native="cancelData()"
        :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
      <el-button primary @click.native="checkErrorsClick()" :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import unsavedData from '@/mixins/unsavedData'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'RegPrasymasSutartis',
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  mixins: [userRole, busena, unsavedData, checkErrors, tooltipNtr],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: {},
      keliosSaskaitos: false,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonlyForm
    },
    saskaitaMask() {
      return 'AA## ##### ###########'
    },
    disabledUzstatoDydis() {
      return this.formData.sut_nenumatyta
    },
    disabledTerminasIki() {
      return this.formData.sut_neterminuota
    },
    terminasNuoLabel() {
      if (this.isPrasymasPanauda) {
        return 'Panaudos sutarties terminas'
      }
      if (this.isPrasymasSubnuoma) {
        return 'Subnuomos sutarties terminas'
      }
      return 'Nuomos sutarties terminas'
    },
    neterminuotaLabel() {
      if (this.isPrasymasPanauda) {
        return 'Panaudos sutartis neterminuota'
      }
      if (this.isPrasymasSubnuoma) {
        return 'Subnuomos sutartis neterminuota'
      }
      return 'Nuomos sutartis neterminuota'
    },
    perdavimoDataLabel() {
      if (this.isPrasymasPanauda) {
        return 'Daikto perdavimo panaudos gavėjui data'
      }
      if (this.isPrasymasSubnuoma) {
        return 'Daikto perdavimo subnuomininkui data'
      }
      return 'Daikto perdavimo nuomininkui data'
    },
    komunaliniaiLabel() {
      if (this.isPrasymasPanauda) {
        return 'Panaudos gavėjas kiekvieną mėnesį panaudos davėjui moka / atlygina Nekilnojamojo daikto komunalinius mokesčius'
      }
      if (this.isPrasymasSubnuoma) {
        return 'Subnuomininkas kiekvieną mėnesį subnuomotojui moka / atlygina Nekilnojamojo daikto komunalinius mokesčius'
      }
      return 'Nuomininkas kiekvieną mėnesį Nuomotojui moka / atlygina Nekilnojamojo daikto komunalinius mokesčius'
    },
    sutartisDataLabel() {
      if (this.isPrasymasIsregistravimas) {
        return 'Sutarties pradžios data'
      }
      return 'Sutarties data'
    },
    sutartiesSalygosLabel() {
      if (this.isPrasymasNutraukimas) {
        return this.$t('Kitos susitarimo sąlygos')
      }
      return this.$t('Kitos šalių numatytos sutarties sąlygos')
    },
    sutartiesSalygosTooltip() {
      if (this.isPrasymasNutraukimas) {
        return `${this.ntrTooltipPrefix} Sutartis. Kitos susitarimo sąlygos`
      }
      return `${this.ntrTooltipPrefix} Sutartis. Kitos šalių numatytos sutarties sąlygos`
    },
    showKeliosSaskaitos() {
      return this.isPrasymasSubnuoma
    },
    showMokejimoInformacija() {
      return this.formData.sut_kelios_saskaitos
    },
    readonlyBankoSaskaita() {
      return this.isReadonlyForm || this.formData.sut_kelios_saskaitos
    },
  },
  watch: {
    keliosSaskaitos(val) {
      this.formData.sut_kelios_saskaitos = val
      if (val) {
        this.formData.sut_banko_saskaita = null
      }
      if (!val) {
        this.formData.sut_mokejimo_informacija = null
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`)
        .then(res => {
          this.formData = res.data.sutartis
          this.keliosSaskaitos = this.formData.sut_kelios_saskaitos
          this.$nextTick(() => {
            this.initialForm()
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      if (toRoute && this.isReadonlyForm) {
        this.goToRoute()
        return
      }
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.pra_id = this.prasymasID

          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`, data)
            .then(res => {
              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkNtrErrors()
                }
              }
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    checkErrorsClick() {
      if (this.isReadonlyForm) {
        this.checkNtrErrors()
        return
      }
      this.saveData(null, 'checkErrors')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 1400px;
}
</style>
